import { ArrayParam, ObjectParam, StringParam, NumericArrayParam } from 'use-query-params'

import { dateFormat } from '@app/constants'
import { FILTERS_PARAMS_KEYS } from '@app/api/constants'
import { columnSearchSchemaOptionType } from '@app/hooks/useTableSearch/сonstants'

import type { TotalMonitoringColumns, TotalMonitoringColumnsSchedule } from './types'
import type { ColumnTableSearchSchema, TableSearchQuerySchema } from '@app/hooks/useTableSearch/types'

export const columnTitleMap: Record<keyof TotalMonitoringColumns, string> = {
  store: 'ТК Ленты',
  cluster: 'Кластер',
  contractor: 'Подрядчик',
  competitors: 'Конкуренты',
  recommendation: 'Рекомендации',
  isLaunchAccess: 'Доступ к запуску'
}

export const columnTitleMapSchedule: Record<keyof TotalMonitoringColumnsSchedule, string> = {
  startAt: 'Старт',
  gettingDateAt: 'Получение данных',
  processingDateAt: 'Обработка данных',
  dateDeadline: 'Выставление новой цены'
}

export const topFiltersQuerySchema = {
  [FILTERS_PARAMS_KEYS.storeIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.excludedStoreIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.clusterIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.excludedClusterIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.salesOrganizationIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.excludedSalesOrganizationIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.contractorIds]: NumericArrayParam,
  [FILTERS_PARAMS_KEYS.excludedContractorIds]: NumericArrayParam
} as const

export const tableSearchQuerySchema: TableSearchQuerySchema<TotalMonitoringColumns & TotalMonitoringColumnsSchedule> = {
  'table-store': StringParam,
  'table-startAt': ObjectParam,
  'table-cluster': StringParam,
  'table-contractor': StringParam,
  'table-dateDeadline': ObjectParam,
  'table-gettingDateAt': ObjectParam,
  'table-processingDateAt': ObjectParam
} as const

const titleWrapperProps = { minWidth: 200 } as const
const titleWrapperDateProps = { minWidth: 215 } as const

export const columnsSearchSchema: ColumnTableSearchSchema<TotalMonitoringColumns & TotalMonitoringColumnsSchedule> = {
  store: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  startAt: {
    type: columnSearchSchemaOptionType.DATE_RANGE,
    titleWrapperProps: titleWrapperDateProps,
    controlProps: { format: dateFormat.DD_MM_YYYY }
  },
  cluster: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  contractor: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  dateDeadline: {
    type: columnSearchSchemaOptionType.DATE_RANGE,
    titleWrapperProps: titleWrapperDateProps,
    controlProps: { format: dateFormat.DD_MM_YYYY }
  },
  gettingDateAt: {
    type: columnSearchSchemaOptionType.DATE_RANGE,
    titleWrapperProps: titleWrapperDateProps,
    controlProps: { format: dateFormat.DD_MM_YYYY }
  },
  processingDateAt: {
    type: columnSearchSchemaOptionType.DATE_RANGE,
    titleWrapperProps: titleWrapperDateProps,
    controlProps: { format: dateFormat.DD_MM_YYYY }
  }
}
